import { render, staticRenderFns } from "./QueuesAsOptions.vue?vue&type=template&id=2866d90a&"
import script from "./QueuesAsOptions.vue?vue&type=script&lang=ts&"
export * from "./QueuesAsOptions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports